import React from 'react'
import isAfter from 'date-fns/isAfter'
import parseISO from 'date-fns/parseISO'

export const getIsPreRelease = (releaseDate: string) => isAfter(parseISO(releaseDate), new Date())

export const useIsPreRelease = (releaseDate?: string) =>
  React.useMemo(() => (releaseDate ? getIsPreRelease(releaseDate) : false), [releaseDate])
